import PasswordToggle from './PasswordToggle';

export default PasswordToggle;
